<template>
    <sa-page-layout :btnRefreshVisible="true" @refresh="onRefresh" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">ASL</label>
                        <b-form-select v-model="filtro.codiceAsl" :options="opzioniAsl"></b-form-select>
                    </b-col>
                    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Codice PAI</label>
                        <b-form-input v-model="filtro.idPai" type="search" placeholder="idPai"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Stato Lettura</label>
                        <b-form-select v-model="filtro.soloNonLetti" :options="opzioniStatoLettura"></b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">Cerca</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">Reset Filtro</b-button>
                        <b-button variant="outline-info" @click="onClickSincronizza">
                            <i class="fas fa-cloud-download-alt"></i>
                            Aggiorna da AnDIamo
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Totale Record: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(idPai)="{ item }">#{{ item.idPai }}</template>
                    <template v-slot:cell(tipoEvento)="{ item }">
                        <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-' + (item.statoLettura === 'LETTO' ? 'aperta' : 'da-programmare')">{{ item.tipoEvento }}</span>
                    </template>
                    <template v-slot:cell(statoLettura)="{ item }">
                        <span v-if="item.statoLettura === 'LETTO'" class="badge badge-success">LETTO</span>
                        <span v-else class="badge badge-warning">DA LEGGERE</span>
                    </template>
                    <template v-slot:cell(actions)="{ item }">
                        <b-button v-if="item.statoLettura !== 'LETTO'" size="sm" variant="outline-info" class="mr-1" @click="onClickPrendiInCarico(item)">
                            <i class="fas fa-hand-holding-medical"></i>
                            Presa in carico
                        </b-button>
                        <b-button size="sm" variant="outline-primary" class="mr-1" @click="onClickRichiediDettaglio(item)">
                            <i class="fas fa-cloud-download-alt"></i>
                            Richiedi Dettaglio
                        </b-button>
                        <router-link :to="{ path: '/andiamo/pai/' + item.idPai, query: { codiceAsl: filtro.codiceAsl || item.codiceAsl } }" class="btn btn-sm btn-outline-secondary">
                            <i class="fas fa-eye"></i>
                            Vedi
                        </router-link>
                    </template>
                </b-table>
            </div>
        </template>
        <template slot="table-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Totale Record: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import AndiamoMixin from "../mixins/AndiamoMixin";

export default {
    components: { SaPageLayout },
    mixins: [UtilityMixin, AndiamoMixin],
    data() {
        return {
            rows: 0,
            perPage: 2000,
            currentPage: 1,
            showModalLoading: false,
            items: [],
            opzioniAsl: [
                { value: "150204", text: "150204" },
                { value: "150205", text: "150205" },
                { value: "150206", text: "150206" },
            ],
            opzioniStatoLettura: [
                { value: true, text: "Solo non letti" },
                { value: false, text: "Tutti" },
            ],
            filtro: { codiceAsl: "150205", idPai: null, soloNonLetti: true },
            fields: [
                { label: "idPai", key: "idPai", sortable: true },
                { label: "idEvento", key: "idEvento" },
                { label: "Tipo Evento", key: "tipoEvento" },
                { label: "Stato", key: "statoLettura" },
                { label: "", key: "actions", tdClass: "sa-table-column-action-double" },
            ],
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.andiamoPaiLocaliPathResource;
            let params = { ...me.filtro, page: me.currentPage, forPage: me.perPage };
            axios
                .get(link, { params: params })
                .then((response) => {
                    me.items = response.data.data.list || [];
                    me.rows = response.data.data.recordsNumber || 0;
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onSubmit() {
            this.currentPage = 1;
            this.loadData();
        },
        onReset() {
            this.filtro = { codiceAsl: "150205", idPai: null, soloNonLetti: true };
            this.currentPage = 1;
            this.loadData();
        },
        onRefresh() {
            this.loadData();
        },
        onClickSincronizza() {
            if (!this.filtro.codiceAsl) {
                this.$bvToast.toast("Seleziona il codice ASL prima di sincronizzare", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            this.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + this.andiamoPaiPathResource;
            axios
                .get(link, { params: { codiceAsl: this.filtro.codiceAsl, soloNonLetti: this.filtro.soloNonLetti } })
                .then((response) => {
                    this.showModalLoading = false;
                    this.$bvToast.toast("Lista PAI aggiornata da AnDIamo (" + (response.data.data ? response.data.data.length : 0) + " eventi non letti)", { title: "", variant: "success", solid: true });
                    this.loadData();
                })
                .catch((error) => {
                    this.showModalLoading = false;
                    this.$bvToast.toast("Errore: " + (error?.response?.data?.messaggio || error.message), { title: "Errore", variant: "danger", solid: true });
                });
        },
        onClickPrendiInCarico(item) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.andiamoPaiPathResource + "/" + item.idPai + "/presa-in-carico/" + item.idEvento;
            axios
                .put(link + "?codiceAsl=" + encodeURIComponent(me.filtro.codiceAsl || item.codiceAsl), {})
                .then(() => {
                    me.$bvToast.toast("Presa in carico confermata", { title: "", variant: "success", solid: true });
                    me.loadData();
                })
                .catch((error) => {
                    me.$bvToast.toast("Errore: " + (error?.response?.data?.messaggio || error.message), { title: "Errore", variant: "danger", solid: true });
                });
        },
        onClickRichiediDettaglio(item) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.andiamoPaiPathResource + "/" + item.idPai;
            axios
                .get(link, { params: { codiceAsl: me.filtro.codiceAsl || item.codiceAsl, tuttiIPei: false } })
                .then(() => {
                    me.showModalLoading = false;
                    me.$bvToast.toast("Dettaglio PAI " + item.idPai + " aggiornato da AnDIamo", { title: "", variant: "success", solid: true });
                })
                .catch((error) => {
                    me.showModalLoading = false;
                    me.$bvToast.toast("Errore: " + (error?.response?.data?.messaggio || error.message), { title: "Errore", variant: "danger", solid: true });
                });
        },
    },
};
</script>

<style scoped>
.sa-siat-badge {
    display: inline-block;
    font-size: 0.9rem;
}
.sa-siat-badge-aperta {
    color: #07af07;
}
.sa-siat-badge-da-programmare {
    color: #e67e22;
}
</style>
